import config from './envs'

function getEnvironmentConfiguration () {
  const ENV_NAME = process.env.REACT_APP_ENV_NAME || 'stg'
  return config[ENV_NAME]
}

export default getEnvironmentConfiguration
